// Tarayıcı çeviri eklentileri (Google Translate vb.) DOM text node'larını
// sardığında React'in commit aşamasındaki removeChild/insertBefore çağrıları
// "Failed to execute 'removeChild' on 'Node'" (NotFoundError) ile çöker.
// Bu savunmacı patch, React'in kendi tuttuğu ağaçla gerçek DOM uyuşmadığında
// çökmeyi önler. (Endüstri-standart workaround.)
if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (child && child.parentNode) {
        // Çeviri eklentisi node'u başka bir parent'a taşımış: gerçek parent'tan sil
        try {
          return child.parentNode.removeChild(child);
        } catch (e) {
          return child;
        }
      }
      return child;
    }
    try {
      return originalRemoveChild.apply(this, arguments);
    } catch (e) {
      return child;
    }
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      try {
        return originalInsertBefore.call(this, newNode, null);
      } catch (e) {
        return newNode;
      }
    }
    try {
      return originalInsertBefore.apply(this, arguments);
    } catch (e) {
      return newNode;
    }
  };
}
